/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  APPROVE_SALES_QC_REQUEST,
  BOOKING_COMPLETE,
  CREATE_SALES_DATA,
  CREATE_SALES_TEMP_DATA,
  DELETE_SALES_TEMP_DATA,
  LOAD_BANK_DETAILS,
  LOAD_RECORDS_META_DATA,
  LOAD_SALES_DATA,
  LOAD_SALES_PENDING,
  LOAD_SALES_QC_HISTORY,
  LOAD_SALES_TEMP_DATA,
  UPDATE_EVENT_DATA,
  UPDATE_SALES_DATA,
  UPDATE_SALES_QC_REAPPROVE,
  UPDATE_SALES_TEMP_DATA,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadSalesList,
  loadSalesListSuccess,
  loadSalesListError,
  createSalesRecordSuccess,
  createSalesRecordError,
  updateSalesRecordSuccess,
  updateSalesRecordError,
  loadSalesTempListSuccess,
  loadSalesTempListError,
  createSalesTempRecordSuccess,
  createSalesTempRecordError,
  updateSalesTempRecordSuccess,
  updateSalesTempRecordError,
  deleteSalesTempRecordSuccess,
  deleteSalesTempRecordError,
  loadBankDetails,
  loadBankDetailsSuccess,
  loadBankDetailsError,
  updateEventRecordSuccess,
  updateEventRecordError,
  loadSalesTempList,
  loadSalesPending,
  loadSalesPendingSuccess,
  loadSalesPendingError,
  loadSalesQcHistory,
  loadSalesQcHistorySuccess,
  approvalSalesRequestQcSuccess,
  approvalSalesRequestQcError,
  updateSalesQcReapproveSuccess,
  updateSalesQcReapproveError,
  loadSalesQcHistoryError,
  bookingCompleteListSuccess,
  bookingCompleteListError,
} from "./actions"

import {
  loadBankDetailsList,
  loadRecordsMetaData,
  loadSalesDetails,
  createSalesRecord,
  updateSalesRecord,
  loadSalesTempDetails,
  createSalesTempRecord,
  updateSalesTempRecord,
  updateEventRecord,
  deleteSalesTempRecord,
  loadSalesPendingDetails,
  loadSalesQcHistoryDetails,
  approvalSalesRequestQc,
  updateSalesReapproveQc,
  bookingCompleteDetails,
} from "./remotes"

// import { selectSession } from "../session/selectors"
// import { roleIds } from "../../helpers/tools"

//Sales List

function* loadSalesDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SALES_DATA),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadSalesList(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesDetails, id)

        if (result) {
          yield put(loadSalesListSuccess(result.data))
        } else {
          yield put(loadSalesListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadSalesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createSalesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_SALES_DATA),
    })
    const { salesListData } = create || {}

    if (create) {
      console.log("records", salesListData)
      try {
        yield call(createSalesRecord, salesListData)

        console.log("create records", salesListData)
        // yield delay(1000)

        var successData = createSalesRecordSuccess(
          salesListData,
          "Record Created Successfully"
        )

        console.log("Submitted Data")

        yield put(successData)
      } catch (error) {
        yield put(
          createSalesRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Update sales saga
function* updateSalesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_SALES_DATA),
    })
    const { salesListData } = create || {}

    if (create) {
      console.log("records", salesListData)
      try {
        yield call(updateSalesRecord, salesListData)

        console.log("create records", salesListData)
        // yield delay(1000)

        var successData = updateSalesRecordSuccess(
          salesListData,
          "Record Updated Successfully"
        )

        console.log("Submitted Data")

        yield put(successData)
      } catch (error) {
        yield put(
          updateSalesRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Sales List

function* loadSalesTempDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SALES_TEMP_DATA),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadSalesTempList(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesTempDetails, id)

        if (result) {
          yield put(loadSalesTempListSuccess(result.data))
        } else {
          yield put(loadSalesTempListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadSalesTempListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createSalesTempSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_SALES_TEMP_DATA),
    })
    const { payments } = create || {}

    if (create) {
      console.log("records", payments)
      try {
        yield call(createSalesTempRecord, payments)

        console.log("create records", payments)
        // yield delay(1000)

        var successData = createSalesTempRecordSuccess(
          payments,
          "Record Created Successfully"
        )

        console.log("Submitted Data")

        yield put(successData)
      } catch (error) {
        yield put(
          createSalesTempRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Update sales saga
function* updateSalesTempSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_SALES_TEMP_DATA),
    })
    const { payments } = create || {}

    if (create) {
      console.log("records", payments)
      try {
        yield call(updateSalesTempRecord, payments)

        console.log("create records", payments)
        // yield delay(1000)

        var successData = updateSalesTempRecordSuccess(
          payments,
          "Record Updated Successfully"
        )

        console.log("Submitted Data")

        yield put(successData)
      } catch (error) {
        yield put(
          updateSalesTempRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Delete sales temp saga

function* deleteSalesTempSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_SALES_TEMP_DATA),
    })
    const { salesTempId } = del || {}
    if (del) {
      // yield call(setSubmitting, true)

      try {
        yield call(deleteSalesTempRecord, salesTempId)
        // yield delay(1000)
        console.log(salesTempId, "saga for delete event")

        yield put(
          deleteSalesTempRecordSuccess(
            salesTempId,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteSalesTempRecordError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Update event saga

function* updateEventSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_EVENT_DATA),
    })
    const { eventData } = create || {}

    if (create) {
      console.log("records", eventData)
      try {
        yield call(updateEventRecord, eventData)

        console.log("create records", eventData)
        // yield delay(1000)

        var successData = updateEventRecordSuccess(
          eventData,
          "Record Updated Successfully"
        )

        console.log("Submitted Data")

        yield put(successData)
      } catch (error) {
        yield put(
          updateEventRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Bank details get saga

function* loadBankDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_BANK_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadBankDetails(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadBankDetailsList, id)

        if (result) {
          yield put(loadBankDetailsSuccess(result.data))
        } else {
          yield put(loadBankDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadBankDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

// Sales Pending approval Saga

function* loadSalesPendingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SALES_PENDING),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadSalesPending(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesPendingDetails, id)

        if (result) {
          yield put(loadSalesPendingSuccess(result.data))
        } else {
          yield put(loadSalesPendingError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadSalesPendingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

// Qc history Saga

function* loadSalesQcHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SALES_QC_HISTORY),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadSalesQcHistory(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesQcHistoryDetails, id)

        if (result) {
          yield put(loadSalesQcHistorySuccess(result.data))
        } else {
          yield put(loadSalesQcHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadSalesQcHistoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Qc approval request

function* approvalSalesRequestSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(APPROVE_SALES_QC_REQUEST),
    })
    const { leadId, leadQuotationId, salesId, remarks } = approve || {}
    if (approve) {
      try {
        yield call(
          approvalSalesRequestQc,
          leadId,
          leadQuotationId,
          salesId,
          remarks
        )
        // yield delay(1000)
        yield put(
          approvalSalesRequestQcSuccess(
            leadId,
            leadQuotationId,
            salesId,
            remarks,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          approvalSalesRequestQcError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Qc Re approval request

function* updateSalesReapprovalQcSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(UPDATE_SALES_QC_REAPPROVE),
    })
    const { qcUpdateData } = approve || {}
    if (approve) {
      try {
        yield call(updateSalesReapproveQc, qcUpdateData)
        // yield delay(1000)
        yield put(
          updateSalesQcReapproveSuccess(
            qcUpdateData,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateSalesQcReapproveError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Update sales saga
function* bookingCompleteSalesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(BOOKING_COMPLETE),
    })
    const { bookingComplete } = create || {}

    if (create) {
      console.log("records", bookingComplete)
      try {
        yield call(bookingCompleteDetails, bookingComplete)

        console.log("create records", bookingComplete)
        // yield delay(1000)
        yield put(
          bookingCompleteListSuccess(
            bookingComplete,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          bookingCompleteListError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const paymentTerms = yield call(
        loadRecordsMetaData,
        "payment_terms",
        "get"
      )
      const gstData = yield call(loadRecordsMetaData, "payment_gst", "get")
      const paymentMode = yield call(
        loadRecordsMetaData,
        "payment_mode",
        "post"
      )
      const bank = yield call(loadRecordsMetaData, "bank_account", "post")
      const reject = yield call(loadRecordsMetaData, "rejectreason", "post")
      let recordsMetaData = {
        paymentGstOptions:
          (gstData &&
            gstData.data &&
            gstData.data.length > 0 &&
            gstData.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.gstName,
                  value: c._id,
                  cgst: c.cgst,
                  sgst: c.sgst,
                  igst: c.igst,
                  description: c.description,
                }
              )
            )) ||
          [],
        paymentTermsOptions:
          (paymentTerms &&
            paymentTerms.data &&
            paymentTerms.data.length > 0 &&
            paymentTerms.data.map((c) =>
              Object.assign({}, { label: c.paymentTerms, value: c._id })
            )) ||
          [],
        paymentModeOptions:
          (paymentMode &&
            paymentMode.data &&
            paymentMode.data.length > 0 &&
            paymentMode.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.paymentMode, value: c._id, mode: c.mode }
                )
              )) ||
          [],
        bankOptions:
          (bank &&
            bank.data &&
            bank.data.length > 0 &&
            bank.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.displayName,
                  value: c._id,
                  companyId: c.companyId,
                  bankId: c.bankId,
                  accountNo: c.accountNo,
                  branchName: c.branchName,
                  isfc: c.isfc,
                  accountType: c.accountType,
                  address: c.address,
                }
              )
            )) ||
          [],
        rejectReasonList:
          (reject &&
            reject.data &&
            reject.data.length > 0 &&
            reject.data.map((c) =>
              Object.assign({}, { label: c.reason, value: c._id })
            )) ||
          (reject &&
            reject.length > 0 &&
            reject.map((c) =>
              Object.assign({}, { label: c.reason, value: c._id })
            )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadSalesDetailsSaga(),
    createSalesSaga(),
    updateSalesSaga(),
    loadSalesTempDetailsSaga(),
    createSalesTempSaga(),
    updateSalesTempSaga(),
    deleteSalesTempSaga(),
    updateEventSaga(),
    loadBankDetailsSaga(),
    loadSalesPendingSaga(),
    loadSalesQcHistorySaga(),
    approvalSalesRequestSaga(),
    updateSalesReapprovalQcSaga(),
    bookingCompleteSalesSaga()
  ])
}
